import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'myclubrewards-congratulations',
  templateUrl: './congratulations.component.html',
  styleUrls: [
    '../../../../../shared/components/modal/modal.component.scss',
    './congratulations.component.scss',
  ],
})
export class CongratulationsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<CongratulationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}
}
